export enum DraftLinkFormat {
  AR = 'ar',
  CapSave = 'cap-save',
  SocialSharing = 'social-sharing',
}
